// extracted by mini-css-extract-plugin
export default {"menuControls":"c-a_eY","menuControls_styleDefault":"c-a_eZ","menuControls_styleRed":"c-a_fa"};